export default "/_next/static/images/5-5375df744cfafd9b58c205955d05e406.png";